module.exports = __webpack_public_path__ + "static/img/bookmarkDefault.429dc5b2.png";